// apps/hub/src/App.tsx
import { lazy } from 'react'
import { createBrowserRouter, Navigate } from 'react-router'
import { RouterProvider } from 'react-router/dom'

import AuthLayout from './components/AuthLayout'
import HubLayout from './components/HubLayout'
import VantaBackground from './components/VantaBackground'

// Lazy loading des pages
const HomePage = lazy(() => import('./pages/HomePage'))
const AiWizardPage = lazy(() => import('./pages/AiWizardPage'))
const ContactPage = lazy(() => import('./pages/ContactPage'))
const LegalPage = lazy(() => import('./pages/LegalPage'))
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'))
const CgvPage = lazy(() => import('./pages/CgvPage'))
const AuthCallbackPage = lazy(() => import('./pages/AuthCallbackPage'))

// ProfilePage est dans shared — pas de fichier local
// ProfilePage shared avec prop app pour conditionner les liens
const ProfilePage = lazy(() =>
  import('@neuroforge/shared/client').then((m) => ({
    default: () => m.ProfilePage({ app: 'hub' }),
  })),
)

// Auth email pages (shared) — import depuis le barrel @neuroforge/shared/client
const LoginPage = lazy(() =>
  import('@neuroforge/shared/client').then((m) => ({ default: m.LoginPage })),
)
const RegisterPage = lazy(() =>
  import('@neuroforge/shared/client').then((m) => ({ default: m.RegisterPage })),
)
const ForgotPasswordPage = lazy(() =>
  import('@neuroforge/shared/client').then((m) => ({ default: m.ForgotPasswordPage })),
)
const ResetPasswordPage = lazy(() =>
  import('@neuroforge/shared/client').then((m) => ({ default: m.ResetPasswordPage })),
)
const VerifyEmailPage = lazy(() =>
  import('@neuroforge/shared/client').then((m) => ({ default: m.VerifyEmailPage })),
)
const NotFoundPage = lazy(() =>
  import('@neuroforge/shared/client').then((m) => ({
    default: () => m.NotFoundPage({ app: 'hub' }),
  })),
)

const router = createBrowserRouter([
  {
    element: <HubLayout />,
    errorElement: <NotFoundPage />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      // {
      //   path: '/labs',
      //   element: <LabsPage />,
      // },
      {
        path: '/profile',
        element: <ProfilePage />,
      },
      {
        path: '/ai-wizard',
        element: <AiWizardPage />,
      },
      {
        path: '/quiz',
        element: <Navigate to="/ai-wizard" replace />,
      },
      {
        path: '/contact',
        element: <ContactPage />,
      },
      {
        path: '/mentions-legales',
        element: <LegalPage />,
      },
      {
        path: '/confidentialite',
        element: <PrivacyPage />,
      },
      {
        path: '/cgv',
        element: <CgvPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
  // Auth routes (hors layout — plein écran). AuthLayout fournit le fallback Suspense
  // que HubLayout assure aux routes internes.
  {
    element: <AuthLayout />,
    errorElement: <NotFoundPage />,
    children: [
      { path: '/auth/login', element: <LoginPage /> },
      { path: '/auth/register', element: <RegisterPage /> },
      { path: '/auth/forgot-password', element: <ForgotPasswordPage /> },
      { path: '/auth/reset-password', element: <ResetPasswordPage /> },
      { path: '/auth/verify-email', element: <VerifyEmailPage /> },
      { path: '/auth/callback', element: <AuthCallbackPage /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
])

export default function App() {
  return (
    <>
      <VantaBackground />
      <RouterProvider router={router} />
    </>
  )
}
